import Vue from 'vue';
import Router from 'vue-router';
// import Home from '@/components/pages/Home.vue';
// import Solution from '@/components/pages/Solution.vue';
import LoginLayout from '@/components/layouts/LoginLayout.vue';
import DashboardLayout from '@/components/layouts/DashboardLayout.vue';
import Login from '@/components/login/Login.vue';
import ForgotPassword from '@/components/login/ForgotPassword.vue';
import ResetPassword from '@/components/login/ResetPassword.vue';
import Dashboard from '@/components/dashboard/Dashboard.vue';
import ParkingHome from '@/components/parking/Home.vue';
import ParkingInformation from '@/components/parking/Information.vue';
import ParkingInvoices from '@/components/parking/Invoices.vue';
import ParkingReports from '@/components/parking/Reports.vue';
import ParkingActivity from '@/components/parking/Activity.vue';
import ParkingAvailability from '@/components/parking/Availability.vue';
import ParkingTenant from '@/components/parking/Tenants.vue';
import Help from '@/components/help/Help.vue';
import Home from '@/components/pages/Home.vue';
import PageNotFound from '@/components/pages/PageNotFound.vue';
import ChileBlocker from '@/components/commons/ChileBlocker.vue';
import store from '@/store';
import _ from 'lodash';
import keys from '@/store/keys';
import localeService from '@/services/localeService'
import {
  EventBus
} from '@/services/eventBus';
import utilService from '@/services/utilService';

Vue.use(Router);

let loginPages = {
  path: '/login',
  component: LoginLayout,
  children: [{
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/forgot-password',
      name: 'ForgotPassword',
      component: ForgotPassword
    },
    {
      path: '/reset-password',
      name: 'ResetPassword',
      component: ResetPassword
    }
  ]
};

let dashboardPages = {
  path: '/',
  component: DashboardLayout,
  children: [{
      path: '/dashboard',
      name: 'Dashboard',
      alias: ['/private'],
      component: Dashboard
    },
    {
      path: '/parking/:id/stats',
      name: 'ParkingHome',
      alias: ['/parking/:id'],
      component: ParkingHome
    },
    {
      path: '/parking/:id/info',
      name: 'ParkingInformation',
      component: ParkingInformation
    },
    {
      path: '/parking/:id/invoices',
      name: 'ParkingInvoices',
      component: ParkingInvoices
    },
    {
      path: '/parking/:id/reports',
      name: 'ParkingReports',
      component: ParkingReports
    },
    {
      path: '/parking/:id/activity',
      name: 'ParkingActivity',
      component: ParkingActivity
    },
    {
      path: '/parking/:id/availabilities',
      name: 'ParkingAvailability',
      component: ParkingAvailability
    },
    {
      path: '/parking/:id/tenants',
      name: 'ParkingTenant',
      component: ParkingTenant
    },
    {
      path: '/help',
      name: 'Help',
      component: Help
    }
  ]
};

const router = new Router({
  mode: 'history',
  routes: [{
      path: '/',
      name: 'Home',
      component: Home,
      alias: ['/es', '/en', '/ca', '/cl', '/index.html']
    },
    loginPages,
    dashboardPages,
    {
      path: '/legal-advice',
      name: 'ChileBlocker',
      component: ChileBlocker
    },
    {
      path: '*',
      name: 'PageNotFound',
      component: PageNotFound
    }
  ]
});

router.beforeEach((to, from, next) => {
  // Verificar si es una página interna (dashboard) y SI es Chile
  const isDashboardPage = to.path.startsWith('/dashboard') || to.path.startsWith('/parking') || to.name === 'Help';
  const isChileBlockerPage = to.name === 'ChileBlocker';

  if (isDashboardPage && !isChileBlockerPage && utilService.isChile()) {
    next('/legal-advice');
    return;
  }

  // Si está en ChileBlocker pero ahora NO es Chile, redirigir al dashboard
  if (isChileBlockerPage && !utilService.isChile()) {
    next('/dashboard');
    return;
  }

  if (to.name === 'ParkingInvoices' && !utilService.showInvoices()) {
    next('/dashboard');
    return;
  }

  let parking = null;
  if (to.path === '/private') {
    next('/dashboard');
    return;
  }
  if (to.name.indexOf('Parking') === 0) {
    let parkingId = Number(to.params.id);
    let parkingSelected = _.find(store.state.parkingList, itParking => {
      return itParking.id === parkingId;
    });
    if (typeof parkingSelected !== 'undefined' && parkingSelected !== null) {
      parking = {
        name: parkingSelected.name,
        alias: parkingSelected.alias,
        fullControl: parkingSelected.fullControl
      };
    }
  }
  if (parking !== null) {
    EventBus.$emit(keys.eventOnParkingSelected, {
      parking: parking
    });
  }

  if (to.name === 'Home') {
    let lang = '';
    let start = to.path.indexOf('/')

    lang = to.path.substr(start + 1, 2);

    if (!_.isEmpty(lang)) {
      localeService.changeLanguage(lang)
    }
  }

  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js